<template>
  <div>
    <div class="flex items-center bg-white h-10 transition ease-in-out focus-within:ring">
      <label for="sort-form" class="sr-only">Sort Results</label>
      <select
        name="sort"
        id="sort-form"
        v-model="selected"
        class="form-select ml-2 2xl:ml-4 pr-6"
      >
        <option value="date_listed|desc">Date Listed</option>
        <option value="list_price|desc">Price - high to low</option>
        <option value="list_price|asc">Price - low to high</option>
        <option value="date_modified|desc">Date Modified</option>
      </select>
      <button
        type="submit"
        class="form-button bg-accent hover:bg-accent-dark h-10 px-4 text-primary-dark flex font-bold items-center flex-shrink"
        @click="submitForm()"
      >
        Sort
      </button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: "PropertySortForm",

  props: {
    searchTerms: {
      type: Object,
      default: () => {
        return {
          area: '',
          propertyType: ''
        }
      },
    },
  },

  data() {
    return {
      selected: "date_listed|desc",
    }
  },

  methods: {
    submitForm() {
      this.$emit('sorted', { sort: this.selected })
    }
  }


})
</script>
